import React, { useState } from "react";
import { Box, Typography, Divider, useTheme, Tabs, Tab } from "@mui/material";
import Header from "../../../components/Header";
import { useNavigate, useParams } from "react-router-dom";
import { useGetLoteByIdQuery } from "../../../services/loteService";
import ErrorComponent from "../../../components/ErrorComponent";
import LoadingComponent from "../../../components/LoadingComponent";
import { getHarvestTypeByValue, getLoteTypeByValue } from "../../../constants/enums";
import { tokens } from "../../../theme";
import BlocksList from "../../../components/BlocksList";
import ForcesList from "../../../components/ForcesList";
import { formatDate } from "../../../utils/formatDate";
import SuccessButton from "../../../components/SuccessButton";

const ViewLote = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: lote, isLoading, error } = useGetLoteByIdQuery(id);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [selectedTab, setSelectedTab] = useState(0);

  if (isLoading) return <LoadingComponent />;
  if (error) return <ErrorComponent />;

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <Box m="20px">
      <Header title="Detalles del Lote" />

      {/* Lote Details Section */}
      <Box
        display="grid"
        gap="10px"
        gridTemplateColumns="repeat(4, minmax(0, 1fr))"
      >
        {/* Lote Name */}
        <Box>
          <Typography variant="subtitle1" fontWeight="bold" color={colors.greenAccent[500]}>
            Nombre del Lote
          </Typography>
          <Typography variant="body1" color={colors.grey[100]}>
            {lote?.name}
          </Typography>
        </Box>

        {/* Lote Number */}
        <Box>
          <Typography variant="subtitle1" fontWeight="bold" color={colors.greenAccent[500]}>
            Número
          </Typography>
          <Typography variant="body1" color={colors.grey[100]}>
            {lote?.number}
          </Typography>
        </Box>

        {/* Lote Type */}
        <Box>
          <Typography variant="subtitle1" fontWeight="bold" color={colors.greenAccent[500]}>
            Tipo de Semilla
          </Typography>
          <Typography variant="body1" color={colors.grey[100]}>
          {getLoteTypeByValue(lote?.type).label}
          </Typography>
        </Box>

        {/* Harvest Tag */}
        <Box>
          <Typography variant="subtitle1" fontWeight="bold" color={colors.greenAccent[500]}>
            Cosecha
          </Typography>
          <Typography variant="body1" color={colors.grey[100]}>
            {getHarvestTypeByValue(lote?.harvest_tag).label}
          </Typography>
        </Box>

        {/* Sowing Date */}
        <Box>
          <Typography variant="subtitle1" fontWeight="bold" color={colors.greenAccent[500]}>
            Fecha de Siembra
          </Typography>
          <Typography variant="body1" color={colors.grey[100]}>
            {formatDate(lote?.sowing_date)}
          </Typography>
        </Box>

        {/* Template */}
        <Box>
          <Typography variant="subtitle1" fontWeight="bold" color={colors.greenAccent[500]}>
            Plan de aplicaciones
          </Typography>
          <Typography variant="body1" color={colors.grey[100]}>
            {lote?.template}
          </Typography>
        </Box>

        {/* Plants */}
        <Box>
          <Typography variant="subtitle1" fontWeight="bold" color={colors.greenAccent[500]}>
            Plantas
          </Typography>
          <Typography variant="body1" color={colors.grey[100]}>
            {lote?.plants}
          </Typography>
        </Box>

        {/* Area */}
        <Box>
          <Typography variant="subtitle1" fontWeight="bold" color={colors.greenAccent[500]}>
            Area
          </Typography>
          <Typography variant="body1" color={colors.grey[100]}>
            {lote?.area}
          </Typography>
        </Box>
      </Box>
      
      {/* Divider */}
      <Divider sx={{ my: "20px", borderColor: colors.grey[700] }} />

      {/* Tabs Section */}
      <Box>
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          centered
        >
          <Tab label="Bloques" />
          <Tab label="Forzas" />
        </Tabs>

        {/* Tab Content */}
        <Box>
          {selectedTab === 0 && (
            <BlocksList
              lote={lote}
              isReadOnly // Set to true to disable editing
            />
          )}
          {selectedTab === 1 && (
            <ForcesList lote={lote} isReadOnly />
          )}
        </Box>
      </Box>
      <Box
        display="flex"
        justifyContent="end"
        gap="4px"
      >
        <SuccessButton label="Ver Lotes" onClick={() => navigate('/lotes')}/>
      </Box>
    </Box>
  );
};

export default ViewLote;